// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"fa97d996","526":"a6e6a275","611":"526549da","808":"6eef27d5","859":"ce6d32d2"}[chunkId] + ".chunk.js";
};